import { Dispatch } from 'redux';
import actionTypes from 'redux/actions/actionTypes';
import { axiosV2 } from 'interceptors/axios';

import { Share } from 'types';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetSharesProps = {
  partnerId: string;
  page: number;
  items: number;
  searchTerm?: string | number;
  sortBy?: string;
  sortOrder?: string;
};

type UpdateShareProps = {
  shareId: string;
  updateShareData: Partial<Share>;
};

export const getShares =
  ({ ...params }: GetSharesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const query = { params: { ...params } };
      const { data } = await axiosV2.get(`/shares`, query);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: actionTypes.GET_SHARES,
        shares: decodedData,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const setShares = (shares: Share[]) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_SHARES,
    shares,
  });
};

export const updateShare =
  ({ shareId, updateShareData }: UpdateShareProps) =>
  async (dispatch: Dispatch) => {
    const body = { ...updateShareData };

    const { data } = await axiosV2.put(`/shares/${shareId}`, body);
    const decodedData = await decryptResponse(data);

    dispatch({
      type: actionTypes.UPDATE_SHARE,
      share: decodedData,
    });

    return decodedData;
  };
